<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <phone-input
      v-model="inputValue"
      :id="inputId"
      :disabled="disabled"
      @input="emitValue('input', $event)"
      @change="emitValue('change', $event)"
      @blur="emitValue('blur', $event)"
    />
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'
import PhoneInput from '../../../inputs/PhoneInput.vue'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'VisitorPhoneInput',

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    visitorsSectionMixin,
    visitorInputMixin
  ],

  components: {
    Hint,
    PhoneInput
  },

  props: {
    inputLabel: {
      default: 'Мобильный телефон'
    },

    inputName: {
      default: 'phone'
    },

    inputHint: {
      default: undefined
    }
  },

  computed: {
    inputId () {
      let inputId = `form-visitor-phone-${this.visitorIndex}`
      if (this.transportIndex !== null) {
        return `form-visitor-transport-${this.transportIndex}-driver-${this.visitorIndex}-phone`
      }

      return inputId
    }
  }
}
</script>
